export default "__VITE_ASSET__0bcc2d05__"